import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Acerca de Nosotros</h1>
      <p>
      Solo los mejores vapes de Oaxaca. Manda tu orden por WhatsApp y te atenderemos
      </p>
    </div>
  );
};

export default About;
